/* global window */
import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

const FloatIfAbove = ({ children, className }) => {
  const [isFloating, setIsFloating] = useState(false)
  const [elementHeight, setElementHeight] = useState(null)

  const containerRef = useRef(null)
  const elementRef = useRef(null)

  useEffect(() => {
    const handleScrollResize = () => {
      if (typeof document === 'undefined') return

      const container = containerRef.current
      const element = elementRef.current

      if (container && element) {
        const containerY = container.getBoundingClientRect().top
        const currentElementHeight = element.clientHeight

        if (currentElementHeight !== elementHeight) {
          setElementHeight(currentElementHeight)
        }

        const bottomSpace = window.innerHeight - (containerY + currentElementHeight)
        const shouldFloat = bottomSpace < 0

        if (shouldFloat !== isFloating) {
          setIsFloating(shouldFloat)
        }
      }
    }

    window.addEventListener('scroll', handleScrollResize)
    window.addEventListener('resize', handleScrollResize)
    handleScrollResize()

    return () => {
      window.removeEventListener('scroll', handleScrollResize)
      window.removeEventListener('resize', handleScrollResize)
    }
  }, [elementHeight, isFloating])

  const floatingStyle = isFloating
    ? {
        position: 'fixed',
        textAlign: 'center',
        left: 0,
        bottom: 0,
        width: '100%',
        boxSizing: 'border-box',
        zIndex: 8,
        transform: 'translateZ(0)'
      }
    : {
        textAlign: 'center'
      }

  return (
    <div
      className={`${className}${isFloating ? ' floating' : ''}`}
      ref={containerRef}
      style={elementHeight ? { height: elementHeight } : {}}
    >
      <div ref={elementRef} style={floatingStyle}>
        {children}
      </div>
    </div>
  )
}

FloatIfAbove.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

export default FloatIfAbove
